var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Header',[_vm._v("One Time Ride List")]),_c('div',{staticClass:"tiled-bar-image"}),_c('Main',[_c('OneTimeRideList')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }